<template>
  <div class="customer-list-wrapper">
    <div class="row">
      <div class="col-md-12">
        <h5>Search By:</h5>
        <div class="m-2 row">
          <div class="col-md-3 form-check-radio">
            <label class="form-check-label">
              <input class="form-check-input" v-model="searchBy" type="radio" name="searchBy" id="customerID" value="customerID"> Customer Id
              <span class="form-check-sign"></span>
            </label>
          </div>
          <div class="col-md-3 form-check-radio">
            <label class="form-check-label">
              <input class="form-check-input" v-model="searchBy" type="radio" name="searchBy" id="hbServiceID" value="hbServiceID"> HB Service ID
              <span class="form-check-sign"></span>
            </label>
          </div>
          <div class="col-md-3 form-check-radio">
            <label class="form-check-label">
              <input class="form-check-input" v-model="searchBy" type="radio" name="searchBy" id="solusVM_VPS_ID" value="solusVM_VPS_ID"> Solus VM_VPS_ID
              <span class="form-check-sign"></span>
            </label>
          </div>
          <div class="col-md-3 form-check-radio">
            <label class="form-check-label">
              <input class="form-check-input" v-model="searchBy" type="radio" name="searchBy" id="hbHostname" value="hbHostname"> HB Hostname
              <span class="form-check-sign"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div v-if="searchBy" class="row my-3">
      <div class="col-md-3">
        <input v-model="searchQuery" type="text" class="form-control mt-2" placeholder="Search in Customer List" />
      </div>
      <div class="col-md-3">
        <button class="btn btn-primary btn-sm" v-on:click="fetchUsers">
          Search
        </button>
        <button class="btn btn-danger btn-sm" v-on:click="refreshFilters">
          Clear
        </button>
      </div>
      <div class="col-md-6">
        <button class="btn btn-success btn-sm mr-2 pull-right" :disabled="selectedAcc.length <= 0 || loading" v-on:click="syncAll">
          <span v-if="loading">
            <div class="loader" style="width: 20px;height: 20px; margin: 0 auto !important;"></div>
          </span>
          <span v-else>Sync Selected</span>
        </button>
      </div>
    </div>
    <div class="customer-list-info">
      <div class="loader" v-if="(accounts.length === 0 && noData === false) || !asyncDone"></div>
      <p class="card-text text-center text-danger my-3 font-weight-bold" v-if="noData && asyncDone">There are no
        Sever details in the database to show here.</p>
    </div>
    <div class="customer-table" v-if="accounts.length > 0 && asyncDone">
      <table class="table table-striped table-bordered w-100">
        <thead>
        <tr>
          <th>Check</th>
          <th>Customer Id</th>
          <th>HB Service ID</th>
          <th>Solus VM_VPS_ID</th>
          <th>HB Hostname</th>
          <th>Action</th>
        </tr>
        </thead>
        <tfoot>
        <tr>
          <th>Check</th>
          <th>Customer Id</th>
          <th>HB Service ID</th>
          <th>Solus VM_VPS_ID</th>
          <th>HB Hostname</th>
          <th>Action</th>
        </tr>
        </tfoot>
        <tbody>
        <tr v-for="(acc, index) in accounts" :key="index">
          <td class="text-center">
            <div class="custom-control custom-checkbox mr-sm-2 d-flex justify-content-center">
              <input type="checkbox" class="custom-control-input" :disabled="loading" name="identifiers" v-model="selectedAcc" :value="acc" :id="'select_' + index"/>
              <label class="custom-control-label" :for="'select_' + index"></label>
            </div>
          </td>
          <td>{{ acc.customerID }}</td>
          <td>
            <input type="text" class="form-control" v-model.trim="acc.hbServiceID">
          </td>
          <td>{{ acc.solusVM_VPS_ID }}</td>
          <td>{{ acc.hbHostname }}</td>
          <td class="text-center">
            <button class="btn btn-primary btn-sm mr-2" @click="sync(acc)">Sync</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="row mt-2">
      <div class="col-md-12 text-center">
        <span class="pull-left mt-2"><b>Page Number: </b> {{ pageNumber + 1 }}</span>
        <button class="btn btn-link btn-sm btn-round" :disabled="pageNumber === 0 || accounts.length <= 0" v-on:click="prevPage">
          Prev
        </button>
        <button class="btn btn-link btn-sm btn-round" :disabled="accounts.length < pageSize" v-on:click="nextPage">
          Next
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init";
import swal from "sweetalert2";

export default {
name: "serversList",
  data() {
    return {
      accounts: [],
      selectedAcc: [],
      noData: false,
      loading: false,
      pageNumber: 0,
      pageSize: 10,
      searchQuery: null,
      searchBy: 'customerID'
    };
  },
  computed: {
    asyncDone() {
      return this.$store.getters["async/state"];
    },
    user() {
      return this.$store.getters.user;
    },
    last () {
      return (this.accounts.length > 0) ? this.accounts[this.accounts.length-1] : null;
    },
    first () {
      return (this.accounts.length > 0) ? this.accounts[0] : null;
    }
  },
  watch: {
    searchBy () {
      this.fetchUsers();
    }
  },
  mounted() {
    this.fetchUsers();
  },
  methods: {
    async syncAll () {
      try {
        this.loading = true
        console.log(this.selectedAcc)
        await this.$http.post('/utilities/bulk-sync-hb-accounts', {
          accounts: this.selectedAcc,
          grant_type: 'token'
        });
        this.addLog({
          message:'HB details has been synchronized!!',
          level: "info"
        })
        swal('SUCCESS!', 'HB details has been synchronized!!', "success");
        this.selectedAcc = []
        this.refreshFilters()
      } catch (e) {
        console.log(e.toString());
        this.addLog({
          message:'Error in syncing HB details',
          level: "danger"
        })
        swal('Error!', 'Error in syncing HB details', "error");
      }
      this.loading = false
    },
    sync (acc) {
      this.selectedAcc = []
      this.selectedAcc.push(acc);
      this.syncAll()
    },
    refreshFilters() {
      this.accounts = [];
      this.selectedAcc = [];
      this.noData = false;
      this.searchQuery = '';
      this.fetchUsers();
    },
    async fetchUsers () {
      this.noData = false;
      this.pageNumber = 0;
      await this.$store.dispatch("async/stateUpdate", {state: false});
      const ref = db.collection('account-hb');
      let docs = [];
      try {
        if (this.searchQuery) {
          docs = await ref
              .where(this.searchBy, "==", this.searchQuery)
              .orderBy("createdAt", "desc")
              .limit(this.pageSize)
              .get();
        } else {
          console.log('here')
          docs = await ref
              .orderBy("createdAt", "desc")
              .limit(this.pageSize)
              .get()
        }
        this.accounts = [];
        console.log(docs.empty)
        if (docs.empty === true) {
          this.noData = true;
        }
        docs.forEach(doc => {
          console.log(doc.data())
          this.accounts.push({
            docID: doc.id,
            ...doc.data()
          })
        });
        await this.$store.dispatch("async/stateUpdate", {state: true});
      } catch (e) {
        console.log(e);
        // Show error message to the customer for 5 sec
        await this.$store.dispatch("alert/update", {
          type: "danger",
          message: e.name,
          show: true
        });
        await this.$store.dispatch("async/stateUpdate", {state: true});
      }
    },
    async prevPage(){
      if (this.first) {
        this.pageNumber --;
        this.noData = false;
        await this.$store.dispatch("async/stateUpdate", {state: false});
        try {
          const ref = db.collection('account-hb');
          let docs = [];
          if (this.searchQuery) {
            docs = await ref
                .where(this.searchBy, "==", this.searchQuery)
                .orderBy("createdAt", "desc")
                .endBefore(this.first.createdAt)
                .limitToLast(this.pageSize)
                .get();
          } else {
            console.log('here')
            docs = await ref
                .orderBy("createdAt", "desc")
                .endBefore(this.first.createdAt)
                .limitToLast(this.pageSize)
                .get()
          }
          this.accounts = [];
          console.log(docs.empty)
          if (docs.empty === true) {
            this.noData = true;
          }
          docs.forEach(doc => {
            console.log(doc.data())
            this.accounts.push({
              docID: doc.id,
              ...doc.data()
            })
          });
          await this.$store.dispatch("async/stateUpdate", {state: true});
        } catch (e) {
          console.log(e);
          // Show error message to the customer for 5 sec
          await this.$store.dispatch("alert/update", {
            type: "danger",
            message: e.name,
            show: true
          });
          await this.$store.dispatch("async/stateUpdate", {state: true});
        }
      }
    },
    async nextPage() {
      if (this.last) {
        this.pageNumber ++;
        this.noData = false;
        await this.$store.dispatch("async/stateUpdate", {state: false});
        try {
          const ref = db.collection('account-hb');
          let docs = [];
          if (this.searchQuery) {
            docs = await ref
                .where(this.searchBy, "==", this.searchQuery)
                .orderBy("createdAt", "desc")
                .startAfter(this.last.createdAt)
                .limit(this.pageSize)
                .get();
          } else {
            console.log('here')
            docs = await ref
                .orderBy("createdAt", "desc")
                .limit(this.pageSize)
                .startAfter(this.last.createdAt)
                .get()
          }
          this.accounts = [];
          console.log(docs.empty)
          if (docs.empty === true) {
            this.noData = true;
          }
          docs.forEach(doc => {
            console.log(doc.data())
            this.accounts.push({
              docID: doc.id,
              ...doc.data()
            })
          });
          await this.$store.dispatch("async/stateUpdate", {state: true});
        } catch (e) {
          console.log(e);
          // Show error message to the customer for 5 sec
          await this.$store.dispatch("alert/update", {
            type: "danger",
            message: e.name,
            show: true
          });
          await this.$store.dispatch("async/stateUpdate", {state: true});
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
